export function initWoo() {
  $(document).on(
    "click",
    ".quantity .increase, .quantity .decrease",
    function (e) {
      e.preventDefault();

      var $this = $(this),
        $qty = $this.siblings(".qty"),
        current = parseInt($qty.val(), 10),
        min = parseInt($qty.attr("min"), 10),
        max = parseInt($qty.attr("max"), 10);

      min = min ? min : 1;
      max = max ? max : current + 1;

      if ($this.hasClass("decrease") && current > min) {
        $qty.val(current - 1);
        $qty.trigger("change");
      }
      if ($this.hasClass("increase") && current < max) {
        $qty.val(current + 1);
        $qty.trigger("change");
      }
    },
  );

  //cart qty
  $(document).on("click", ".qty-btn.plus", function () {
    let input = $(this).siblings(".qty");

    input.val(parseInt(input.val()) + 1).trigger("change");
  });

  $(document).on("click", ".qty-btn.minus", function () {
    let input = $(this).siblings(".qty");

    let value = parseInt(input.val());

    if (value > 1) {
      input.val(value - 1).trigger("change");
    }
  });

  $(document).on("change", ".qty", function () {
    let qty = $(this).val();

    $(this)
      .closest(".product-actions")
      .find(".add_to_cart_button")
      .attr("data-quantity", qty);
  });

  /////////////////

  function initShopFilters() {
    const shop = document.querySelector("#tienda");

    if (!shop) return;

    const products = shop.querySelector(".tienda-productos");
    const pagination = shop.querySelector(".tienda-paginacion");

    let currentCategory =
      shop.querySelector(".tienda-filtro.active")?.dataset.category || "all";

    let loading = false;

    const loadProducts = async (
      category = "all",
      page = 1,
      updateUrl = true,
    ) => {
      if (loading) return;

      loading = true;
      shop.classList.add("is-loading");

      const formData = new FormData();

      formData.append("action", "martinez_filter_products");
      formData.append("nonce", shop.dataset.nonce);
      formData.append("category", category);
      formData.append("page", page);

      try {
        const response = await fetch(shop.dataset.ajaxUrl, {
          method: "POST",
          body: formData,
        });

        const data = await response.json();

        if (!data.success) return;

        products.innerHTML = data.data.html;

        if (pagination) {
          pagination.innerHTML = data.data.pagination;
        }

        currentCategory = category;

        shop.querySelectorAll(".tienda-filtro").forEach((button) => {
          button.classList.toggle(
            "active",
            button.dataset.category === category,
          );
        });

        if (updateUrl) {
          const url = new URL(window.location.href);

          if (category === "all") {
            url.searchParams.delete("categoria");
          } else {
            url.searchParams.set("categoria", category);
          }

          if (page > 1) {
            url.searchParams.set("pagina", page);
          } else {
            url.searchParams.delete("pagina");
          }

          history.pushState(
            {
              category,
              page,
            },
            "",
            url,
          );
        }

        if (typeof ScrollTrigger !== "undefined") {
          ScrollTrigger.refresh();
        }
      } catch (error) {
        console.error("Error filtrando productos:", error);
      } finally {
        loading = false;
        shop.classList.remove("is-loading");
      }
    };

    shop.addEventListener("click", (e) => {
      const filter = e.target.closest(".tienda-filtro");

      if (filter) {
        loadProducts(filter.dataset.category, 1);
        return;
      }

      const page = e.target.closest(".tienda-paginacion [data-page]");

      if (page) {
        loadProducts(currentCategory, Number(page.dataset.page));

        shop.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    });

    window.addEventListener("popstate", () => {
      const url = new URL(window.location.href);

      loadProducts(
        url.searchParams.get("categoria") || "all",
        Number(url.searchParams.get("pagina")) || 1,
        false,
      );
    });
  }

  initShopFilters();
}
